import { RemoveDish } from '../index'

export default function RemoveDishFunc(currDishId: string) {
  return RemoveDish(currDishId)
}
